import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { OAuthService } from '@partner/core/services/oauth.service';
import { Router } from '@angular/router';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {
  private publicEndpoints: string[] = [
    '/token',
    '/companies/branding'
  ]

  constructor(private oauthService: OAuthService,private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const requestUrl = request.url;
    const isRequestToPublicUrl = this.publicEndpoints.some(publicEndpoint => requestUrl.endsWith(publicEndpoint));
    if(isRequestToPublicUrl) {
      return next.handle(request);
    }

    //RD: We need to skip execution if this reqest is for token endpoint which means that we want to get access token after login or we want to refresh existing expired token
    if (!this.oauthService.accessToken)
      return next.handle(request);

    if (!this.oauthService.authenticated) {
      return this.oauthService.refreshAuthToken().pipe(switchMap((res) => {
          if (!res?.access_token) {
              this.oauthService.sessionEndLocal();
              sessionStorage.setItem('navigation.history', window.location.pathname);
              this.router.navigate(["sign-in"]);
              return EMPTY;
          }

          this.oauthService.sessionBegin(
              localStorage.loginType,
              res?.access_token,
              res?.expires_in,
              res?.refresh_token,
              res?.refresh_token_expires_in,
              localStorage.clientId);

            return next.handle(request);
      }), catchError((err) => {
        sessionStorage.setItem('navigation.history', window.location.pathname);
        this.router.navigate(["sign-in"]);
        return EMPTY;
      }));
    } else {
        this.oauthService.restartIdleTimer();
        return next.handle(request);
    }
  }
}
